"use strict";

var _toConsumableArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Cell_1 = require("../../ui/Cell");

var Detail = __importStar(require("./detail"));

var footer_1 = __importDefault(require("./footer"));

var load_1 = require("../../data/load");

var tabs_1 = __importDefault(require("../../ui/tabs"));

var utils_1 = __importDefault(require("@nexys/utils"));

var DetailUnit = function DetailUnit(props) {
  var ViewUI = props.ViewUI,
      FormUI = props.FormUI,
      Data = props.Data,
      config = props.config,
      uuid = props.match.params.uuid,
      data = props.data;
  var displayType = config.displayType ? config.displayType : 'toggle';

  if (displayType === 'toggle') {
    return react_1.default.createElement(Detail.WToggle, {
      data: data,
      id: uuid,
      ViewUI: ViewUI,
      FormUI: FormUI,
      Data: Data
    });
  }

  if (displayType === 'view') {
    return react_1.default.createElement(Detail.JustView, {
      id: uuid,
      data: data,
      ViewUI: ViewUI
    });
  }

  return react_1.default.createElement(Detail.JustForm, {
    data: data,
    id: uuid,
    linkBack: config.urlPrefix,
    FormUI: FormUI,
    Data: Data
  });
};

var Extras = function Extras(props) {
  return react_1.default.createElement(react_1.default.Fragment, null, props.extras.filter(function (unit) {
    return !!unit.Component;
  }).map(function (unit, i) {
    return react_1.default.createElement(Cell_1.Cell, Object.assign({
      key: i,
      title: unit.title
    }, unit.width), unit.Component(props.uuid, props.data));
  }));
};

var ExtraPreLoader = function ExtraPreLoader(p) {
  return react_1.default.createElement(load_1.WithLoader, {
    Component: Extras,
    dataLoad: p.dataLoad(p.uuid),
    uuid: p.uuid,
    extras: p.extras
  });
};

var getTabs = function getTabs(extras) {
  var empty = [];

  if (!extras || extras.length === 0) {
    return [['null', empty]];
  }

  var g = utils_1.default.ds.groupBy(extras, 'tab');

  if (!g['null']) {
    g['null'] = empty;
  }

  return Object.entries(g);
};

var PageWithData = function PageWithData(props) {
  var _props$Data = props.Data,
      detail = _props$Data.detail,
      deleteById = _props$Data.deleteById,
      _props$config = props.config,
      urlPrefix = _props$config.urlPrefix,
      _props$config$title = _props$config.title,
      title = _props$config$title === void 0 ? 'Detail' : _props$config$title,
      displayType = _props$config.displayType,
      showDelete = _props$config.showDelete,
      uuid = props.match.params.uuid,
      _props$extra = props.extra,
      extra = _props$extra === void 0 ? [] : _props$extra,
      onBack = props.onBack,
      onDelete = props.onDelete;

  var DetailComponent = function DetailComponent(uuid, data) {
    return react_1.default.createElement(DetailUnit, Object.assign({
      data: data
    }, props));
  };

  var DetailAsExtra = {
    title: title,
    width: props.config.width,
    Component: DetailComponent
  };
  var tabs = getTabs(extra).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    var extras = k === 'null' ? [DetailAsExtra].concat(_toConsumableArray(v)) : v;
    var label = k === 'null' ? 'Detail' : k;
    var link = k === 'null' ? '/detail' : '/' + encodeURI(k);
    return {
      label: label,
      link: link,
      Component: react_1.default.createElement(Cell_1.CellLayout, null, react_1.default.createElement(ExtraPreLoader, {
        dataLoad: detail,
        uuid: uuid,
        extras: extras
      }))
    };
  });
  var detailIndex = 0;
  var detailItem = tabs.filter(function (x, i) {
    if (x.link === '/detail') {
      detailIndex = i;
      return true;
    }

    return false;
  })[0];

  if (detailIndex !== 0) {
    tabs.splice(detailIndex);
    tabs.unshift(detailItem);
  }

  return react_1.default.createElement(react_1.default.Fragment, null, tabs.length === 1 ? tabs[0].Component : react_1.default.createElement(tabs_1.default, {
    prefix: urlPrefix + '/' + uuid,
    tabs: tabs,
    exact: false
  }), react_1.default.createElement(footer_1.default, {
    id: uuid,
    linkBack: urlPrefix,
    deletePromise: deleteById,
    displayType: displayType,
    showDelete: showDelete,
    onBack: onBack,
    onDelete: onDelete
  }));
};

exports.default = PageWithData;